<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h3 class="text-bold">Create New Order</h3>
      </div>
      <div class="add-fabric-div">
        <!-- select fabric -->
        <table class="table add-fabric">
          <tbody>
            <tr>
              <td width="250">
                <v-select
                  class="select-fabric"
                  :options="fieldValues.fabrics"
                  :value="fabric.fabric"
                  label="production_name"
                  @input="setFabric"
                  placeholder="Select Fabric"
                />
                <small v-if="error.fabric_id" class="text-danger"
                  >Required Fabric</small
                >
              </td>
              <td width="180">
                <money
                  v-model="fabric.amount"
                  placeholder="Length"
                  class="form-control text-right"
                  v-bind="fieldValues.money"
                ></money>
                <small v-if="error.amount" class="text-danger"
                  >Required Amount</small
                >
              </td>
              <td width="180">
                <div class="form-group">
                  <v-select
                    placeholder="Choose One"
                    v-model="fabric.default_unit"
                    :reduce="(unit) => unit.value"
                    :options="[
                      { value: 'm', label: 'Meter' },
                      { value: 'y', label: 'Yard' },
                      { value: 'kg', label: 'Kilogram' },
                    ]"
                    label="label"
                    class="unit"
                  />
                </div>
                <small v-if="error.default_unit" class="text-danger"
                  >The selected unit is not correct</small
                >
              </td>
              <td width="300">
                <v-select
                  class="bg-white br-5"
                  :options="fieldValues.suppliers"
                  :value="fabric.selectedSupplier"
                  @input="setSupplier"
                  label="full_name"
                  placeholder="Choose One"
                />
                <small v-if="error.supplier" class="text-danger"
                  >Required Supplier</small
                >
              </td>
              <td>
                <button class="btn btn-success" @click="addFabricToOrder()">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Add
                  Fabric
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <order-list
        :orders="orders"
        @create-order="confirmToOrder"
        :fieldValues="fieldValues"
      />
    </div>

    <!-- Order creating Modal -->
    <div
      id="post-order-creation-modal"
      class="modal"
      role="dialog"
      data-backdrop="static"
      v-if="showModal"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="hidePostOrderCreationModal()"
            >
              &times;
            </button>
            <h4 class="modal-title text-left">Message to Supplier</h4>
          </div>
          <div class="modal-body bg-white">
            <div class="well" id="copy-text">
              Dear {{ selected.supplier.contact }}<br /><br />

              I would like to place the following order:<br /><br />

              <span v-for="(fabric, index) in selected.fabrics" :key="index">
                - {{ fabric.amount }} {{ fabric.default_unit }} of
                <strong>
                  ( {{ fabric.name }} -
                  {{ fabric.current_fabric_supplier_code }}) </strong
                ><br />
              </span>

              <br />Could you give me an ETA for those fabrics?<br /><br />

              Best regards,<br />
              Befeni
            </div>
            <button
              @click="hidePostOrderCreationModal()"
              class="btn mt-5 btn-info btn-large"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from "./components/OrderList";
import app from "../Tools/Fabric";
import { Money } from "v-money";

export default {
  components: {
    OrderList,
    Money,
  },
  data() {
    return {
      showModal: false,
      selected: {},
      fabric: {
        fabric: null,
        amount: null,
        default_unit: "m",
        selectedSupplier: null,
      },
      fieldValues: { fabrics: [] },
      nextOrderId: 0,
      error: {},
      orders: [],
    };
  },
  mounted() {
    this.getFabrics();
    this.getPageData();
  },
  methods: {
    hidePostOrderCreationModal() {
      hide_modal("#post-order-creation-modal");
      this.showModal = false;
    },

    async confirmToOrder(index) {
      let result = await Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        await this.createOrder(index);
      }
    },

    async createOrder(index) {
      let orders = [this.orders[index]];
      this.showModal = true;
      this.selected = this.orders[index];

      try {
        let res = await axios.post("/v2/fabrics/orders", { orders });

        if (res) {
          setTimeout(() => {
            show_modal("#post-order-creation-modal");
          }, 200);
          this.orders.splice(index, 1);
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } if (error.response.status === 422) {
          toastr.error(error.response.data.message);
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fieldValues.fabrics = res.data.data.collection;
    },

    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/orders/create",
        });

        let data = results.data.data;

        this.nextOrderId = data.next_order_id;
        // load the field values
        this.fieldValues.weaves = data.weaves;
        this.fieldValues.fibers = data.fibers;
        this.fieldValues.finishes = data.finishes;
        this.fieldValues.patterns = data.patterns;
        this.fieldValues.coloringStyles = data.coloringStyles;
        this.fieldValues.fabricTypes = data.fabricTypes;
        this.fieldValues.buttonColors = data.buttonColors;
        this.fieldValues.threadColors = data.threadColors;
        this.fieldValues.embroideryThreadColors = data.embroideryThreadColors;
        this.fieldValues.suppliers = data.suppliers;
        this.fieldValues.compositionLabels = data.compositionLabels;
        this.fieldValues.interlinings = data.interlinings;
        this.fieldValues.interliningColors = data.interliningColors;
        this.fieldValues.formattedCompositionLabels = app.getFormattedCompositionLabels(
          data.compositionLabels
        );
        this.fieldValues.certificates = data.certificates;

        this.setSupplier(data.default_supplier);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          let msg = error.response.data.message;
          toastr.error(msg);
        }
      }
    },
    setSupplier(supplier) {
      this.fabric.selectedSupplier = supplier;
    },

    setFabric(fabric) {
      if (fabric) {
        let newArray = this.fieldValues.suppliers.filter((s) => {
          return s.id === fabric.current_fabric_supplier_id;
        });
        if (newArray.length > 0) {
          this.fabric.selectedSupplier = newArray[0];
        } else {
          this.fabric.selectedSupplier = null;
        }
        this.fabric.fabric = fabric;

        this.fabric.default_unit = fabric.default_unit;
      } else {
        this.fabric.selectedSupplier = null;
      }
    },

    async addFabricToOrder() {
      /**
       * Validate user inputs
       */
      this.error = {};
      if (!this.fabric.fabric) {
        this.error.fabric_id = true;
      }
      if (!this.fabric.amount || this.fabric.amount * 1 == 0) {
        this.error.amount = true;
      }
      if (!this.fabric.selectedSupplier) {
        this.error.supplier = true;
      }

      if (this.fabric.fabric) {
        if ((this.fabric.fabric.is_jersey && this.fabric.default_unit !== 'kg')
          || (!this.fabric.fabric.is_jersey && this.fabric.default_unit === 'kg')) {
          this.error.default_unit = true;
        }
      }

      if (Object.keys(this.error).length > 0) {
        return false;
      } else {
        let supplier = this.fabric.selectedSupplier;

        try {
          /**
           * Get config from latest supplier order
           */
          let res = await axios.get(
            `v2/fabrics/${this.fabric.fabric.id}/configuration/last_supplier_order?supplier_id=${supplier.id}`
          );
          let loadedConfig = res.data.data.loaded;
          let config = res.data.data.config;

          const fabric = {
            ...config,
            ...{
              default_unit: this.fabric.default_unit,
              amount      : this.fabric.amount,
              is_jersey   : this.fabric.fabric.is_jersey
            },
          };

          if (loadedConfig === "latest") {
            toastr.success(
              "Lastest supplier configuration loaded successfully"
            );
          }

          if (loadedConfig === "default") {
            toastr.warning(
              "Lastest supplier configuration not found, loading default !!!"
            );
          }

          /**
           * Check if we already added an order group for the current supplier.
           * If it's the case, we just add a new fabric to the order group.
           * If not, create a new order group for the supplier
           */
          let supplierIndex = this.orders.findIndex(
            (order) => order.supplier_id === supplier.id
          );

          if (supplierIndex === -1) {
            /**
             * If the order group does not exists,
             * create a new order group
             */

            let order = {
              supplier_id: supplier.id,
              nextOrderId: this.nextOrderId,
              invoice_date: moment().format(),
              supplier: supplier,
              fabrics: [],
              postfix: "",
              order_reference: null,
              currency: "THB",
            };
            this.nextOrderId++;
            let lastInsertedIndex = this.orders.push(order) - 1;

            // Append the new order to the list of current order
            this.orders[lastInsertedIndex].fabrics.push(fabric);
          } else {
            /**
             * If the order group already exists,
             * Add the new fabric in the order group
             */
            let fabrics = this.orders[supplierIndex].fabrics;
            let fabricIndex = fabrics.findIndex((f) => f.id === fabric.id);
            if (fabricIndex === -1) {
              this.orders[supplierIndex].fabrics.push(fabric);
            } else {
              toastr.error("Same Fabric Already Exist");
            }
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    }, //end of add fabric function
  },
};
</script>

<style scoped>
.form-control {
  height: 42px;
  border-radius: 4px;
}
.add-fabric tbody > tr > td {
  vertical-align: top;
}
.btn {
  height: 42px;
}
.table {
  margin-bottom: 0px;
}
.add-fabric-div {
  position: sticky;
  top: 60px;
  background: white;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  z-index: 99;
}
</style>
